import { Component, EventEmitter, forwardRef, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

import * as routing from '../../../_model/routing';

import { CompanyService } from 'src/app/_service/company.service';
import { TenantService } from 'src/app/_service/tenant.service';
import { TranslateService } from '@ngx-translate/core';
import { postTenantData, tenantForm, rbac } from 'src/app/_model/tenant';
import { getCompanyData } from 'src/app/_model/company';
import { RbacEditComponent } from '../rbac-edit/rbac-edit.component';
import { UserService } from 'src/app/_service/user.service';

@Component({
  selector: 'app-tenant-register',
  templateUrl: './tenant-register.component.html',
  styleUrl: './tenant-register.component.css'
})
export class TenantRegisterComponent implements OnInit, OnDestroy {
  @Output() dataChange = new EventEmitter();
  form = new tenantForm;
  tenantForm = this.form.defaultForm;
  tenantData!: postTenantData;
  isSubmitting = false;
  editUserFlag = false;
  selectedRids: number[] = [0];
  vslDict: { [key: string]: {name: string, vessels: any[]}} = {}
  currSelectedCompany: string = '';
  currSelectedVessels = new Set<string>();

  constructor(
    private location: Location,
    private companyService: CompanyService,
    private tenantService: TenantService,
    private userService: UserService,
    private translate: TranslateService,
    public router: Router,
    public dialog: MatDialog,
  ) {
    this.companyList = this.companyService.companyList;
  }

  roleOptions = [
    { label: "globalAdmin", id: 3, alwaysChecked: true, },
    { label: "admin", id: 0, alwaysChecked: true, },
    { label: "user", id: 1, alwaysChecked: false, },
    { label: "thirdParty", id: 2, alwaysChecked: false, },
  ];

  companyList: getCompanyData[];

  ngOnInit(): void {
    this.editUserFlag = this.userService.editUserFlag
  }

  ngOnDestroy(): void {
    this.tenantForm.reset();
  }

  onRoleSelectionChange(event: any, id: number) {
    if (event.target.checked) {
      this.selectedRids.push(id);
    } else {
      this.selectedRids = this.selectedRids.filter(rid => rid !== id);
    }
  }

  addCompany() {
    const dialogRef = this.dialog.open(RbacEditComponent, {
      width:'798px',
      height: '460px',
      data: { selectedCompanies: Object.keys(this.vslDict) },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result)
        this.vslDict[result?.currSelectedCompany?.id] = {name: result?.currSelectedCompany?.name, vessels: result?.selectedVesselList};
    });
  }

  getSelectedCompanies() {
    return Object.entries(this.vslDict).map(([id, { name }]) => ({
      id,
      name,
    }));
  }

  removeVessel(companyId: string, vesselId: string) {
    if (this.vslDict[companyId]) {
      this.vslDict[companyId].vessels = this.vslDict[companyId].vessels.filter(vessel => vessel.id != vesselId);
    }
  }

  removeCompany(companyId: string) {
    delete this.vslDict[companyId];
  }

  onSubmit() {
    if(this.checkSubmit()){
      if (this.tenantForm.value?.expiration_date == "")
        this.tenantForm.patchValue({expiration_date: null});
      const allVsl = [];
      for (const companyId in this.vslDict) {
        if (this.vslDict[companyId].vessels) {
          const currIds = this.vslDict[companyId].vessels.map(v => v.id);
          allVsl.push(...currIds);
        }
      }
      const currRbac: rbac[] = [{
        mgr: Object.keys(this.vslDict),
        vsl: allVsl,
        rids: this.selectedRids,
      }];
      this.tenantForm.patchValue({rbac: currRbac});
      this.tenantService.createTenant(this.tenantForm.value)
        .subscribe({
          error: () => {
            window.alert(this.translate.instant("err"));
          },
          next: (newTenant: any) => {
            if (this.editUserFlag) this.userService.editUserData.tenant_id = newTenant?.id;
          },
          complete: () => {
            this.updateTenantList();
            window.alert(this.translate.instant("created"));
            this.location.back();
            this.tenantForm.reset();
            this.dataChange.emit;
          }
        });
    }
  }

  updateTenantList() {
    this.tenantService.tenantList = [];
  }

  checkSubmit() {
    if(window.confirm('Can I register this?')){
      return true;
    }else{
      return false;
    }
  }

  goBack(){
    this.location.back();
  }
}
